import { IActiveSkill } from "../ISkill";
import { IArrowCaster } from "../IArrowCaster";

export default class PincerSkill implements IActiveSkill {
  Name = "Pincer";
  Description = "Fire an arrow that pierces through enemies, hitting each only once.";
  MaxLevel = 5;
  IconKey = "skill_pincer";
  KeyBinding = "TWO";

  ManaCost(level: number): number {
    return Math.max(15, 35 - level * 4);
  }

  CooldownMs(level: number): number {
    return Math.max(1500, 4000 - level * 500);
  }

  Execute(level: number, caster: IArrowCaster): boolean {
    caster.SpawnArrow({
      angle: caster.GetAimAngle(),
      damageMultiplier: 1.0,
      speedMultiplier: 1.2,
      isExploding: false,
      explosionRadius: 0,
      explosionDmgMult: 0,
      isPiercing: true,
    });
    return true;
  }
}
